import React from "react";
import {StandardLayout} from "../../../../components/StandardLayout";
import {Section} from "../Section";
import {LoadingView} from "../../../../designSystem/components/LoadingView";
import {SearchBar} from "../../../../designSystem/components/SearchBar";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {Dialog} from "../../../../designSystem/components/Dialog";

import {RuleList} from "../RuleList";
import {RuleEditor} from "../RuleEditor";
import {RobotManagementDialog} from "../DialogRobotManagement";

import {useExportRules} from "../../hooks/useExportRules";
import {useRules} from "../../hooks/useRules";
import {useRobotManagementState} from "../../hooks/useRobotManagementState";
import {useRuleMutations} from "../../hooks/useRuleMutations";
import {useFilteredRules} from "../../hooks/useFilteredRules";
import {isRuleSubmitValid} from "../../model/isRuleSubmitValid";

export const RobotManagementFeature = ({ userToken }) => {
  const {rules, isLoading, fetchRules} = useRules({userToken});
  const {
    editingRule,
    selectedId,
    dialogContent,
    searchTerm,
    setEditingRule,
    setSelectedId,
    setDialogContent,
    setSearchTerm,
    newRule,
    updateEditingRule,
  } = useRobotManagementState();
  const {removeRule, toggleRule, selectRule, saveRule} = useRuleMutations({
    userToken,
    rules,
    editingRule,
    setEditingRule,
    setSelectedId,
    setDialogContent,
    fetchRules,
  });

  const { exportData } = useExportRules({ data: rules })
  const {filteredRules} = useFilteredRules({rules, searchTerm});
  const isSubmitValid = isRuleSubmitValid(editingRule);
  const handleCloseDialog = () => setDialogContent("");

  // Rendering
  if (isLoading || !userToken)
    return <LoadingView/>


  return (
    <React.Fragment>
      <StandardLayout
        headerTitle="聊天機器人管理"
        headerActionOnClick={newRule}
        headerActionLabel={"新增規則"}
        body={
          <div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-5 h-[calc(100vh-120px)] overflow-y-scroll p-5">
                <div className="flex justify-between gap-2 items-center mb-2">
                  <SearchBar
                    placeholder="搜尋規則" value={searchTerm}
                    onChangeValue={(value: string) => setSearchTerm(value)}
                  />
                  <div className="p-3">
                    <ActionButton label="匯出列表" onClick={exportData} iconName="fa-file-export" variant="outline" />
                  </div>
                </div>
                <RuleList
                  rules={filteredRules}
                  selectedId={selectedId}
                  onSelect={selectRule}
                  onToggle={toggleRule}
                />
              </div>
              <div className="col-span-7 h-[calc(100vh-120px)] overflow-y-scroll p-5">
                <Section
                  title={editingRule ? '當使用者輸入以下關鍵字' : ''}
                  right={
                    <div className="flex flex-row gap-x-2">
                      {editingRule?.id &&
                        <ActionButton
                          color="warning"
                          label="刪除"
                          onClick={() => removeRule(editingRule.id)}
                          iconName="fa-trash"
                        />
                      }
                      {editingRule &&
                        <ActionButton
                          label="儲存"
                          disabled={!isSubmitValid}
                          onClick={saveRule}
                          iconName="fa-save"
                        />
                      }
                    </div>
                  }
                >
                  <RuleEditor
                    rule={editingRule}
                    onChange={value => updateEditingRule(value)}
                  />
                </Section>
              </div>
            </div>
          </div>
        }
      />
      <Dialog
        isOpen={dialogContent !== ''}
        onBackdropClick={handleCloseDialog}
      >
        {RobotManagementDialog()[dialogContent] || <></>}
      </Dialog>
    </React.Fragment>
  )
}
